<template>
  <div class="wrapper">
    <div class="top">
      <div class="tabs">
        <div
          class="tab"
          v-for="(item,index) in orderTypes"
          :key="index"
          @click="changeOrderType(index)"
        >
					<span :class="{'active':statusIndex == index, 'item': true}">{{item.name}}</span>
					<span v-show="index" class="num" :class="item.value > 0?'active':''">{{item.value}}</span>
				</div>
      </div>
      <div class="search">
        <input type="text" v-model="keyword" @input="inputChange" 
          placeholder="Enter Information to search" class="search-input">
        <div class="search-icon-wrap">
          <div class="search-icon" @click="searchOrder()">
            <i class="el-icon-search"></i>
          </div>
        </div>
		<img class="close-btn" v-show="keyword" src="../../assets/images/close.png" alt="" @click="delKeyword()">
      </div>
    </div>
    <div class="order-wrap">
      <div class="order-head order-box">
        <div class="order-info">Product</div>
        <div class="order-price">Price</div>
        <div class="order-num">Unit</div>
        <div class="order-total-price">{{$t('total', {text: $t('price')})}}</div>
        <div class="order-state">Order Status</div>
        <div class="order-handle">{{$t('action')}}</div>
      </div>
      <div v-if="orderList.length==0" class="no-order">
        <div v-show="statusIndex>0">{{$t('noFoundOrderTips', {text: orderTypes[statusIndex].name} )}} </div>
        <div v-show="statusIndex==0">{{$t('noOrderTips')}}</div>
      </div>
      <div v-show="orderList.length>0">
        <div class="order-item" v-for="(order,index) in orderList" :key="index">
          <div class="order-item-head">
            <span class="time">{{orderTime(order.ctime)}}</span>
            Order Numbers：
            <span class="code">{{order.order_id}}</span>
          </div>
          <div class="order-item-main order-box">
            <div class="order-info-list">
              <div class="order-li" v-for="(product,i) in order.items" :key="i">
                <img :src="product.image_url" alt class="order-img">
                <div class="order-name">{{product.name}}</div>
                <div class="order-price">{{$t('currencySymbol')}} {{product.price}}</div>
                <div class="order-num">
                  <i class="icon iconfont iconchenghao">{{product.nums}}</i>
                </div>
              </div>
            </div>
            <div class="order-total-price">{{$t('currencySymbol')}} {{order.order_amount}}</div>
            <div class="order-state">
              <div class="order-status">{{getOrderStatus(order)}}</div>
              <router-link
                :to="{name:'orderDetail',params:{order_id:order.order_id}}"
                class="order-detail-link"
                tag="a"
              >Order Details</router-link>
            </div>
            <div class="order-handle">
              <template v-if="order.status === 1 && order.pay_status === 1">
                <router-link :to="{name:'cashier',params:{order_id:order.order_id}}">{{$t('toPay')}}</router-link>
              </template>
              <template
                v-else-if="order.status === 1 && order.pay_status === 2 && order.ship_status === 3 && order.confirm === 1"
              >
                <span @click="tackDelivery(order.order_id)">{{$t('receiving')}}</span>
              </template>
              <template
                v-else-if="order.status === 1 && order.pay_status === 2 && order.ship_status === 3 && order.confirm === 2 && order.is_comment === 1"
              >
                <router-link :to="{name:'evaluate',query:{order_id:order.order_id}}">{{$t('evaluate')}}</router-link>
              </template>
              <template v-else>
                <span>
                  <router-link :to="{name:'detail',params:{goodsId:order.items[0].goods_id}}">{{$t('buyAgain')}}</router-link>
                </span>
              </template>
            </div>
          </div>
        </div>
        <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import { timeToDate } from "@/utils";
export default {
  name: "MyOrder",
  components: { Pagination },
  props: {},
  data() {
    return {
      orderTypes: [
				{name: this.$t('all'), value: 0}, 
				{name: this.$t('obligation'), value: 0},
				{name: this.$t('pending'), value: 0},  
				{name: this.$t('waitForReceiving'), value: 0},
				{name: this.$t('waitForEvaluate'), value: 0},
				{name: this.$t('finished'), value: 0}
      ],
      keyword: "",
      statusIndex: 0,
      orderList: [],
      totalPage: 0,
      page: 1,
      limit: 10
    };
  },
  watch: {
    statusIndex(){
      this.initData();
      this.$route.query.type=this.statusIndex;
    }
  },
  computed: {
    orderTime() {
      return time => {
        return timeToDate(time);
      };
    },
    //获取订单状态文字显示
    getOrderStatus() {
      return order => {
        let orderStatusName;
        switch (order.status) {
          case 1:
            if (order.pay_status === 1) {
              orderStatusName = this.$t('obligation');
            }
            if (order.pay_status === 2 && order.ship_status === 1) {
              orderStatusName = this.$t('pending');
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 1
            ) {
              orderStatusName = this.$t('waitForReceiving');
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 1
            ) {
              orderStatusName = this.$t('waitForEvaluate');
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 2
            ) {
              orderStatusName = this.$t('haveEvaluation');
            }
            if (order.pay_status === 4) {
              orderStatusName = this.$t('afterSaleList');
            }
            break;
          case 2:
            orderStatusName = this.$t('finished');
            break;
          case 3:
            orderStatusName = "Cancelled" //this.$t('cancel');
            break;
        }
        return orderStatusName;
      };
    }
  },
  methods: {
		getOrderNums() {
		  this.$api.getOrderStatusSum().then(res => {
		    if (res.status) {
		      const data = res.data;
					this.orderTypes[1].value = data[1]
					this.orderTypes[2].value = data[2]
					this.orderTypes[3].value = data[3]
					this.orderTypes[4].value = data[4]
					this.orderTypes[5].value = data[6]
		    }
		  });
		},
	inputChange() {
	},
    initData() {
      this.orderList = [];
      this.getOrderList();
    },
    changeOrderType(index) {
			console.log('dfgv')
      if (this.statusIndex == index) return;
      this.statusIndex = index;
			console.log(this.statusIndex)
    },
    //分页加载
    handOrderMore(val) {
      this.page = val;
      this.getOrderList();
    },
    //确认收货
    tackDelivery(order_id) {
      this.$confirm(this.$t('confirmReceiptOfGoods'), this.$t('tips'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then(() => {
        let data = {
          order_id: order_id
        };
        this.$api.confirmOrder(data).then(res => {
          if (res.status) {
            this.$msg(this.$t('setSuccess'));
            this.getOrderList();
          }
        });
      });
    },
	searchOrder(){
		this.getOrderList();
	},
	//删除关键词
	delKeyword(){
		this.keyword='';
		this.getOrderList();
	},
    getOrderList() {
      let data = {
        page: this.page,
        limit: this.limit,
        status: this.statusIndex
      };
	  if(this.keyword){
		  data.keyword = this.keyword;
	  }
      this.$api.orderList(data).then(res => {
        if (res.status) {
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          );
          this.orderList = res.data.list;
        }
      });
    }
  },
  created() {
		this.getOrderNums()
	},
  mounted() {
    let query=this.$route.query;
    if(query.type){
      this.statusIndex=query.type
    }
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.order-item {
  border: 1px solid $border;
  box-sizing: border-box;
  margin-bottom: 20px;
  .order-item-head {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #757575;
    padding-left: 20px;
    border-bottom: 1px solid $border;
    .time {
      margin-right: 30px;
    }
  }
}
.order-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  &.order-item-main {
    height: 100%;
    .order-info-list {
      border-right: 1px solid $border;
      width: 500px;
      .order-li {
        display: flex;
        align-items: center;
        &:not(:last-of-type) {
          border-bottom: 1px solid $border;
        }
        .order-img {
          display: block;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
        }
        .order-name {
          width: 200px;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
  &.order-head {
    @include line-height(40px);
    border-top: 1px solid $border;
    border-bottom: 1px solid $border;
    margin: 20px 0;
  }
  .order-info {
    width: 310px;
    text-indent: 20px;
  }
  .order-price {
    width: 100px;
    text-align: center;
  }
  .order-num {
    width: 90px;
    text-align: center;
    .icon {
      font-size: 12px;
    }
  }
  .order-total-price {
    width: 120px;
    text-align: center;
  }
  .order-state {
    width: 150px;
    text-align: center;
    .order-status {
      margin-bottom: 10px;
    }
    .order-detail-link {
      &:hover {
        color: $theme-color;
      }
    }
  }
  .order-handle {
    width: 150px;
    text-align: center;
    span,
    a {
      padding: 5px 0;
      cursor: pointer;
      &:hover {
        color: $theme-color;
      }
    }
  }
}
.wrapper {
  .top {
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
    .tabs {
      margin-top: 20px;
      .tab {
        float: left;
        padding: 0 20px;
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
        &:first-of-type {
          padding-left: 0;
        }
        &:not(:last-of-type) {
          border-right: 1px solid $border;
        }
				.item {
					color: #000;
					height: 18px;
					line-height: 18px;
					cursor: pointer;
				}
        span {
          color: $theme-color;
        }
				.active {
				  color: $theme-color!important;
				}
				.num {
				  display: inline-block;
				  width: 18px;
				  height: 18px;
				  line-height: 18px;
				  border-radius: 2px;
				  background: #b0b0b0;
				  text-align: center;
				  color: #fff;
					margin-left: 5px;
				  &.active {
				    background: $theme-color;
				  }
				}
      }

		}
    .search {
      width: 355px;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(220, 220, 220, 1);
      padding: 10px 0 10px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.2s;
      position: relative;
	  .close-btn {
		  position: absolute;
		  right: 50px;
		  top: 50%;
		  transform: translateY(-50%);
		  width: 20px;
		  height: 20px;
	  }
      &.active {
        border: 1px solid $theme-color;
      }
      .search-input {
        display: block;
        flex: 1;
        height: 20px;
      }
      .search-icon-wrap {
        display: inline-block;
        width: 40px;
        height: 40px;
        position: relative;
        border-left: 1px solid rgba(220, 220, 220, 1);
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
          color: #fff;
          background: $theme-color;
        }
        &.active {
          border-color: $theme-color;
        }
        .search-icon {
          position: absolute;
          width: 20px;
          height: 20px;
          top: 10px;
          left: 10px;
          .el-icon-search {
            font-size: 20px;
          }
        }
      }
    }
  }
}
.no-order {
  height: 100px;
  line-height: 100px;
  text-align: center;
  font-size: 18px;
}
</style>